import React, { useState } from "react";
import { siteContent } from "../content";

const links = [
  { label: "Home", path: "/" },
  { label: "Artists", path: "/artists" },
  { label: "Highlights", path: "/highlights" },
  { label: "Shop", path: "/shop" },
  { label: "Contact", path: "/contact" }
];

export default function Navbar({ onNavigate, currentPath }) {
  const [open, setOpen] = useState(false);

  const handleNav = (event, path) => {
    event.preventDefault();
    setOpen(false);
    onNavigate(path);
  };

  return (
    <header className="sticky top-0 z-30 border-b border-white/10 bg-black/60 backdrop-blur-lg">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-4 py-3">
        <button
          onClick={(e) => handleNav(e, "/")}
          className="flex items-center gap-3 text-left"
        >
          <div className="h-10 w-10 rounded-xl overflow-hidden border border-white/10 bg-white/5 flex items-center justify-center">
            <img
              src={siteContent.brand.logo}
              alt={siteContent.brand.name}
              className="h-full w-full object-cover"
            />
          </div>
          <div>
            <div className="text-sm uppercase tracking-[0.2em] text-amber-200/80">
              Duo
            </div>
            <div className="text-lg font-bold text-white">
              {siteContent.brand.name}
            </div>
          </div>
        </button>

        <nav className="hidden md:flex items-center gap-6">
          {links.map((link) => (
            <a
              key={link.path}
              href={link.path}
              onClick={(e) => handleNav(e, link.path)}
              className={`text-sm font-semibold transition hover:text-amber-200 ${
                currentPath === link.path ? "text-amber-200" : "text-gray-200"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="/contact"
            onClick={(e) => handleNav(e, "/contact")}
            className="inline-flex items-center gap-2 rounded-full bg-amber-400 text-black font-semibold px-4 py-2 shadow-lg hover:shadow-amber-400/30 hover:-translate-y-0.5 transition"
          >
            {siteContent.brand.primaryCta}
          </a>
        </nav>

        <button
          className="md:hidden text-white"
          aria-label="Toggle navigation"
          onClick={() => setOpen((prev) => !prev)}
        >
          <span className="sr-only">Menu</span>
          <div className="space-y-1.5">
            <span className="block w-7 h-0.5 bg-white" />
            <span className="block w-7 h-0.5 bg-white" />
            <span className="block w-5 h-0.5 bg-white" />
          </div>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/70 backdrop-blur-lg">
          <div className="px-4 py-3 space-y-2">
            {links.map((link) => (
              <a
                key={link.path}
                href={link.path}
                onClick={(e) => handleNav(e, link.path)}
                className={`block rounded-xl px-3 py-2 text-sm font-semibold transition ${
                  currentPath === link.path
                    ? "bg-white/10 text-amber-200"
                    : "text-gray-200 hover:bg-white/5"
                }`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="/contact"
              onClick={(e) => handleNav(e, "/contact")}
              className="block text-center rounded-xl px-3 py-2 text-sm font-semibold bg-amber-400 text-black shadow-lg"
            >
              {siteContent.brand.primaryCta}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
